import { BareModal } from '@cb/apricot-react'
import { useState } from 'react'
import { getAge } from '@myap/ui-library'
import RegistrationForm from '../../profileandreg/RegistrationForm'
import { adjustModalHeight } from '../../../../utilities/dom'
import { useAnalyticsStudentRegStep2Event } from '../../../../hooks/analyticsHooks'
import { BIG_FUTURE, SAVE } from './constants'
import useStudentJoinCourseDetailsQuery from '../../hooks/useStudentJoinCourseDetailsQuery'
import useStudentSectionDetailsQuery from '../../hooks/useStudentSectionDetailsQuery'
import useUserSettingsQuery from '../../../../hooks/useUserSettingsQuery'
import useStudentInfoAndRegistrationQuery from '../../hooks/useStudentInfoAndRegistrationQuery'
import { BFS_MINIMUM_AGE } from '../../profileandreg/constants'

const ID = 'studentRegistrationModal'

function StudentRegistrationModal({ changeStep }) {
  const [ open, setOpen ] = useState(true)
  const isStandAlone = typeof changeStep !== 'function'
  const useAnimation = true

  // Get user details
  const {
    educationPeriod: { code: educationPeriod, hasEnrollments },
  } = useUserSettingsQuery()
  const refresh = !hasEnrollments && !isStandAlone
  // Find if course is bfs eligible
  const { data: joinCourseData } = useStudentJoinCourseDetailsQuery({})
  // Get student info and registration
  const { data } = useStudentInfoAndRegistrationQuery({
    educationPeriod,
    refresh,
  })

  const studentBfsEligible = (data?.dob ? getAge(data.dob) >= BFS_MINIMUM_AGE : false) && data?.bfsDomestic
  const { data: sectionDetailsData } = useStudentSectionDetailsQuery({
    enrollmentCode: joinCourseData?.enrollmentCode,
    otherSkipConditions: isStandAlone || !studentBfsEligible,
  })

  useAnalyticsStudentRegStep2Event()

  const adjustHeight = () => adjustModalHeight(`#${ID}`)

  return (
    <BareModal
      modalId={ID}
      open={open}
      openAnimation={useAnimation}
      closeAnimation={useAnimation}
      clickOverlayToClose={!isStandAlone}
      escClose={!isStandAlone}
      shadowRoot
      modalNode
      onClose={() => setOpen(false)}
    >
      {open ? (
        <RegistrationForm
          changeStep={changeStep}
          nextStep={
            !isStandAlone && studentBfsEligible && sectionDetailsData?.bfsEligible
              ? BIG_FUTURE
              : SAVE
          }
          setOpen={setOpen}
          isDismissable={!isStandAlone}
          adjustHeight={adjustHeight}
        />
      ) : (
        <div className="cb-modal-content">
          <span className="sr-only">modal content</span>
        </div>
      )}
    </BareModal>
  )
}

export default StudentRegistrationModal
